export default __webpack_public_path__ + "media/images/images/icons/nike-2d35a6120a0c642529b39b0a044ef80e.png";